import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import reducers from "./";
import type { AppDispatch } from "../store";
import { createMemoryHistory } from "history";

export const useAppDispatch: () => AppDispatch = useDispatch;

const rootReducer = reducers(createMemoryHistory());

export type RootState = ReturnType<typeof rootReducer>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

